import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { useTranslation } from 'next-i18next'
import { Dispatch, Fragment } from 'react'
import { Button } from '@captaincause/ui/Button'
import { Icon } from '@captaincause/ui/Icon'
import { tm } from '@captaincause/ui/tm'
import type { Action, SortingFilter, SortingTag } from './Filtersbar'

type SortingButton = {
  tag: SortingTag
  content: string
}

type SortingMenuProps = {
  dispatch: Dispatch<Action>
  currentSortingTag: SortingFilter
}

export function SortingMenu({ dispatch, currentSortingTag }: SortingMenuProps) {
  const { t } = useTranslation('filters.component')

  const buttonList: SortingButton[] = [
    {
      tag: 'no_sorting',
      content: t('no-sorting'),
    },
    {
      tag: 'by_amount_asc',
      content: t('by-amount-asc'),
    },
    {
      tag: 'by_contributor_desc',
      content: t('by-contributor-desc'),
    },
  ]

  const onClick = (tag: SortingTag) => {
    dispatch({
      type: 'SORTING_TAG',
      category: 'sorting',
      tag,
    })
  }
  const currentFilter =
    buttonList.find(({ tag }) => tag === currentSortingTag) || buttonList[0]

  const shouldHighlight = currentFilter.tag !== buttonList[0].tag

  return (
    <Menu as="div" className="relative z-20 flex items-center">
      <MenuButton
        className={tm(
          'flex max-h-10 items-center whitespace-nowrap rounded-lg border border-inside bg-white px-3 py-3 text-sm font-semibold hover:bg-light-gray',
          shouldHighlight && 'border-[1.5px] border-black',
        )}
      >
        <Icon
          icon="arrow-up-down"
          className="rounded-sm lg:mr-2"
          size="small"
        />
        <span className="hidden lg:block">{currentFilter.content}</span>
      </MenuButton>
      <MenuItems
        anchor={{ to: 'bottom end', gap: '4px' }}
        transition
        className="rounded-md border border-inside bg-white shadow-lg transition-transform duration-100 focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0"
      >
        {buttonList.map(({ tag, content }) => (
          <MenuItem key={content} as={Fragment}>
            {({ focus }) => (
              <Button
                variant="naked"
                onClick={() => {
                  onClick(tag)
                }}
                className={tm(
                  'whitespace-nowrap rounded-md px-4 py-3',
                  focus && 'block',
                  currentSortingTag === tag && 'bg-light-gray',
                )}
                innerClassName="flex text-sm items-center w-full justify-between"
                full
              >
                {content}
              </Button>
            )}
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  )
}
